import { startTransition } from "react";
import { lazy, Suspense, useEffect, useMemo } from "react";
import { Spinner } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const popoutComponentRegistry = new Map();
export const registerPopoutComponent = (sid, load) => {
    if (!sid) {
        throw new Error('Components registered with the popout registry must have a sid!');
    }
    popoutComponentRegistry.set(sid, lazy(load));
}

const Popout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const args = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        let args = null;
        if (searchParams.has('args')) {
            args = JSON.parse(searchParams.get('args'));
        }
        searchParams.delete('args');
        return args;
    }, [location.search]);

    const { component } = useParams();
    const Clazz = useMemo(() => popoutComponentRegistry.get(component), [component]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.has('token') || params.has('refreshToken')) {
            params.delete('token');
            params.delete('refreshToken');
    
            const newSearch = params.toString();
            const newUrl =
                window.location.pathname +
                (newSearch ? `?${newSearch}` : '') +
                window.location.hash;
    
            // Replace current entry without reloading:
            window.history.replaceState({}, '', newUrl);
            startTransition(() => navigate({ ...location, search: params.toString() }));
        }
    }, [navigate, location]);

    return <div style={{ display: 'relative', height: 'calc(100vh)'}}>
        <Suspense fallback={<Spinner></Spinner>}>
            {Clazz ? <Clazz {...args}></Clazz> : null}
        </Suspense>
    </div>
}

export default Popout;